export enum LoadStateEnum {
    AIPendient = "0",
    AIProcessed = "1",
    Loaded = "2",
    Cancel  = "3",
    Error = "4"
}

export enum LineStateEnum {
    AIPendient = "0",
    AIProcessed = "1",
    Loaded = "2",
    Cancel = "3",
    Error = "4"
}


